import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { FAQS } from '../data/content';
import './FAQSection.css';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section className="section faq-section" id="faq">
      <div className="sec-in">
        <div style={{ textAlign: 'center', marginBottom: 36 }}>
          <div className="eyebrow">FAQ</div>
          <div className="sec-title">Common questions answered</div>
        </div>

        <div className="faq-list">
          {FAQS.map((f, i) => (
            <div key={i} className="faq-item">
              <button
                className={`faq-q ${openIndex === i ? 'open' : ''}`}
                onClick={() => toggle(i)}
              >
                {f.q}
                <span className={`faq-ico ${openIndex === i ? 'open' : ''}`}>
                  <ChevronDown size={18} strokeWidth={2} />
                </span>
              </button>
              <div className={`faq-a ${openIndex === i ? 'open' : ''}`}>
                {f.a}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
